import { useCallback, useState } from 'react'
import { postWithToken } from './http'

interface UserRewardIdentifier {
  id: string
  revision: number
}

interface BulkDownloadRequest {
  rootOrganizationId: string
  periodId: string
  userRewards: UserRewardIdentifier[]
}

interface BulkDownloadResponse {
  requestId: string
  message: string
  rewardCount: number
}

export const useBulkDownloadRewards = (token: string) => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const requestBulkDownload = useCallback(
    async (request: BulkDownloadRequest): Promise<BulkDownloadResponse | null> => {
      setIsLoading(true)
      setError(null)

      try {
        const response = await postWithToken('rewards/bulk-download', token, request)
        return response as BulkDownloadResponse
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to request bulk download'
        setError(errorMessage)
        return null
      } finally {
        setIsLoading(false)
      }
    },
    [token]
  )

  return {
    requestBulkDownload,
    isLoading,
    error,
  }
}
